"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Components = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _constant = require("../../styles/constant");
var _FormElements = require("../../styles/FormElements");
var _templateObject, _templateObject2;
const variants = {
  inputFit: _FormElements.inputFit,
  inputVariant: _FormElements.inputVariant,
  inputErrorFocusVariant: _FormElements.inputErrorFocusVariant,
  inputFocusVariant: _FormElements.inputFocusVariant,
  paddingVariant: _FormElements.paddingVariant
};
const Area = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  position: relative;\n  transform: translateX(0);\n  border-radius: ", ";\n  display: flex;\n  justify-content: end;\n  > div {\n    position: absolute;\n  }\n"])), (0, _constant.get)('borderRadius.l'));
const Input = _styledComponents["default"].input(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n  ", "\n  ", "\n  ", "\n  padding-right: ", ";\n  border-color: ", ";\n  &:hover {\n    border-color: ", ";\n  }\n  ", "\n  ", "\n  ::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: ", ";\n  }\n  ::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: ", ";\n  }\n"])), variants.inputFit, variants.inputVariant, _FormElements.BasicInputStyle, props => (props.icon && props.iconPosition === 'left' || props.prefix) && _FormElements.paddingVariant, props => props.clearButton && (props.icon && props.iconPosition === 'right' || props.suffix) ? (0, _constant.get)('space.80') : props.clearButton || props.icon && props.iconPosition === 'right' || props.suffix ? (0, _constant.get)('space.40') : 'unset', props => props.error ? (0, _constant.get)('colors.feedback.danger.normal') : (0, _constant.get)('colors.functional.grey.400'), props => props.error ? (0, _constant.get)('colors.feedback.danger.normal') : (0, _constant.get)('colors.functional.grey.600'), props => props.error ? variants.inputErrorFocusVariant : variants.inputFocusVariant, _ref => {
  let {
    select
  } = _ref;
  return select ? 'cursor: pointer;' : '';
}, (0, _constant.get)('space.0'), (0, _constant.get)('space.0'));
const ClearIconButtons = _FormElements.ClearIconButton;
const Components = exports.Components = {
  Area,
  ClearIconButtons,
  Prefix: _FormElements.Prefix,
  Suffix: _FormElements.Suffix,
  Input,
  LoadingIndicator: _FormElements.LoadingIndicator
};